export const getProjectThumbnailUrl = (project: any) => {
  return project?.thumbnail?.coverUrl || '';
};
